<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">
  <hr #separator>
</idt-common-styles-render>
